$(document).on('click', '.ratings > button', function () {
    let $btn = $(this);

    if ($btn.hasClass('pending')) {
        return false;
    }

    let $ratings = $btn.closest('.ratings');

    $.ajax({
        type: 'POST',
        url: $btn.data('action'),
        beforeSend: function () {
            $btn.addClass('pending');
        },
        success: function (response) {
            $ratings.find('.btn-like span.value').text(response.like_count);
            $ratings.find('.btn-dislike span.value').text(response.dislike_count);
        },
        complete: function () {
            $btn.removeClass('pending');
        }
    });
});
